import React from 'react';
import PropTypes from 'prop-types';

export const IconSandClock = ({ className }) => (
  <svg width="30" height="30" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M3.00033 2.66666H0.666992V0.333328H19.3337V2.66666H17.0003V5C17.0003 6.88466 16.0481 8.40046 14.8491 9.63944C14.0291 10.4868 13.0313 11.2673 12.0197 12C13.0313 12.7327 14.0291 13.5132 14.8491 14.3605C16.0481 15.5995 17.0003 17.1154 17.0003 19V21.3333H19.3337V23.6667H0.666992V21.3333H3.00033V19C3.00033 17.1154 3.95251 15.5995 5.15154 14.3605C5.97162 13.5132 6.96935 12.7327 7.98094 12C6.96935 11.2673 5.97162 10.4868 5.15154 9.63944C3.95251 8.40046 3.00033 6.88466 3.00033 5V2.66666ZM5.33366 2.66666V5C5.33366 6.03199 5.83981 6.99537 6.82828 8.0168C7.67633 8.89315 8.78092 9.7131 10.0003 10.5744C11.2197 9.7131 12.3243 8.89315 13.1724 8.0168C14.1609 6.99537 14.667 6.03199 14.667 5V2.66666H5.33366ZM10.0003 13.4255C8.78092 14.2869 7.67633 15.1068 6.82828 15.9832C5.83981 17.0046 5.33366 17.968 5.33366 19V21.3333H14.667V19C14.667 17.968 14.1609 17.0046 13.1724 15.9832C12.3243 15.1068 11.2197 14.2869 10.0003 13.4255Z" fill="white" />
  </svg>
);

IconSandClock.propTypes = {
  className: PropTypes.string,
};
IconSandClock.defaultProps = {
  className: '',
};
